import HttpService from "~/Scripts/services/httpService";

const instance = new HttpService( "umbraco/api/License/" );

/* eslint-disable arrow-body-style */

/**
 * Get an org's address
 */
export const getAddress = ( orderLineId ) => {
  return instance.get( "GetAddress", { orderLineId } );
};

/**
 * Save an address to an orderline
 */
export const saveAddress = ( orderLineId, orgId ) => {
  return instance.post( "SaveAddress", null, { orderLineId, orgId } );
};
